import React from 'react';
import { MainLayout } from '@components';
import LabResultsComponents from './LabResults';

export default function LabResultsPage(props) {
  return (
    <MainLayout footer="main" children={<LabResultsComponents {...props} />} />
  );
}
